import tencentColor from './main.vue'
tencentColor.install = function(vue) {
  vue.component(tencentColor.name, tencentColor)
}
export default tencentColor



// WEBPACK FOOTER //
// ./src/ui/components/yywColor/index.js